import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { fetchOblacDrivesReleases } from 'motion-master-client';
import { from } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { loadReleasesRequest, loadReleasesSuccess } from './release.actions';
import { Release } from './release.model';

@Injectable()
export class ReleaseEffects {
  private actions$ = inject(Actions);

  handleLoadReleasesRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadReleasesRequest),
      switchMap(() =>
        from(fetchOblacDrivesReleases()).pipe(
          map((releases: Release[][]) => loadReleasesSuccess({ releases: [].concat(...releases) })),
        ),
      ),
    ),
  );
}
